<template>
  <auth-layout>
    <div class="w-full md:w-11/12 mx-auto text-darkBlue px-3">
      <div class="w-full md:w-4/5 mx-auto mt-4">
        <p class="text-sm pl-3">
          Enter verification code sent to {{ userEmail }}
        </p>
        <form class="auth-code-form mt-4" @submit.prevent>
          <div class="flex items-center sm:w-full md:w-96">
            <!-- <div class="flex items-center mx-auto sm:w-full md:w-96"> -->
            <div class="auth-input-boxes">
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="5"
                v-model="authenticationCode.first" @keyup="changeInputField" @paste="pasteCode($event)" autofocus />
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="1"
                v-model="authenticationCode.second" @keyup="changeInputField" />
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="1"
                v-model="authenticationCode.third" @keyup="changeInputField" />
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="1"
                v-model="authenticationCode.fourth" @keyup="changeInputField" />
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="1"
                v-model="authenticationCode.fifth" @keyup="changeInputField" />
              <input type="text" class="single-code-input no-outline" placeholder="--" maxlength="1"
                v-model="authenticationCode.sixth" @keyup="changeInputField" />
            </div>
            <div class="verification-status" v-if="codeSubmitted">
              <div class="verification successful" v-if="successfullyVerified">
                <img src="@/assets/images/checkmark.png" alt="checkmark" class="img-fluid" />
              </div>
              <div class="verification failed cursor-pointer" v-else @click="resetCodeFields">
                <img src="@/assets/images/cancel.png" alt="checkmark" class="img-fluid" />
              </div>
            </div>
          </div>
          <small class="mt-3" v-if="codeSubmitted && !successfullyVerified">Incorrect or expired verification code. To
            resend code,
            <span class="text-danger cursor-pointer" @click="resendVerificationCode">click here</span>.</small>

          <div class="mt-10 mb-8" v-if="!successfullyVerified">
            <base-button text="Submit" width="w-full" p="px-12 py-2" @click="verifyAuthenticationCode"
              :loading="loading" />
          </div>

          <div class="no-mail">
            <small>
              Didn't get the email?
              <span @click="resendVerificationCode" class="text-primary-blue font-medium cursor-pointer">
                Click here
              </span>
            </small>
          </div>
        </form>
        <hr class="my-3" />

        <div v-if="successfullyVerified">
          <div class="">
            <h1 class="font-semibold text-lg">Choose a Password</h1>
            <div class="mt-2">
              <label class="label font-semibold">Password <span class="text-red-500">*</span></label>
              <base-input type="password" placeholder="Enter Your Password" v-model="password">
                <template v-slot:icon>
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                      stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </template>
              </base-input>
            </div>
            <div class="mt-2">
              <label class="label font-semibold">Confirm Password <span class="text-red-500">*</span></label>
              <base-input type="password" placeholder="Confirm Your Password" v-model="password_confirmation"
                errorText="Passwords do not match!" :validation="password == password_confirmation">
                <template v-slot:icon>
                  <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M8.45118 10.8262V12.7355M1.58551 7.64408V17.1905H15.3169V7.64408H1.58551ZM4.08212 7.64408C4.08212 3.8255 4.08212 1.27979 8.45118 1.27979C12.8202 1.27979 12.8202 3.8255 12.8202 7.64408H4.08212Z"
                      stroke="#FCC210" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                  </svg>
                </template>
              </base-input>
            </div>
          </div>

          <div class="shadow mt-8 px-3 py-3">
            <h1 class="font-bold text-lg">Password Requirement</h1>
            <p class="text-sm py-2">
              All passwords must satisfy these requirements. Passwords Must
              have:
            </p>
            <div class="text-sm">
              <p class="flex items-center py-1">
                <span v-if="hasUpperCase" class="pr-1">
                  <checkmark />
                </span>Must have at least 1 upper case character
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasLowercase" class="pr-1">
                  <checkmark />
                </span>Must have at least 1 lower case character
              </p>

              <p class="flex items-center py-1">
                <span v-if="hasNumber" class="pr-1">
                  <checkmark />
                </span>Must
                have at least 1 number
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasSpecialChars" class="pr-1">
                  <checkmark />
                </span>Must have at least 1 special character or symbol
              </p>
              <p class="flex items-center py-1">
                <span v-if="hasEightChars" class="pr-1">
                  <checkmark />
                </span>Must be at least 8 characters
              </p>
            </div>
          </div>
          <div class="mt-10 mb-8">
            <base-button text="Submit" width="w-full" p="px-12 py-2" @click="submitPassword" :loading="loading" />
          </div>
        </div>
      </div>
    </div>

    <template v-slot:text>
      <div class="text-white">
        <h1 class="text-3xl font-bold">
          You’ve successfully created an account
        </h1>
        <p class="text-sm">
          One last step and you are all good to go. An email with a verification
          code has been sent to you
        </p>
      </div>
    </template>
  </auth-layout>
</template>

<script>
import AuthLayout from "../Authlayout/OnDemand";
import changeInputField from "@/mixins/changeInput";
import Checkmark from "./Checkmark.vue";

export default {
  components: {
    AuthLayout,
    Checkmark,
  },

  data() {
    return {
      authenticationCode: {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      },
      password: "",
      password_confirmation: "",
      verifyingAuthCode: false,
      isCreatePassword: false,
      codeSubmitted: false,
      loading: false,
      successfullyVerified: false,
      verificationResent: false,
      resendingVerificationCode: false,
      codeVerified: false,
      // unsuccessfullyVerified: false
    };
  },
  mounted() {
    let code = this.$route.query.code
    let splitCode = String(code).split('').map(String)
    
    if (this.$route.query.auth == 'true' || this.$route.query.auth) {
      this.successfullyVerified = true
      this.codeSubmitted = true
      this.authenticationCode.first = splitCode[0]
      this.authenticationCode.second = splitCode[1]
      this.authenticationCode.third = splitCode[2]
      this.authenticationCode.fourth = splitCode[3]
      this.authenticationCode.fifth = splitCode[4]
      this.authenticationCode.sixth = splitCode[5]
    }
  },
  computed: {
    userEmail() {
      let user = JSON.parse(localStorage.getItem("account-owner"));
      if (user) {
        return user.email;
      } else {
        return "";
      }
    },
    hasEightChars() {
      return this.password.length >= 8 ? true : false;
    },
    hasUpperCase() {
      return /[A-Z]/.test(this.password);
    },
    hasLowercase() {
      return /[a-z]/.test(this.password);
    },
    hasNumber() {
      return /\d/.test(this.password);
    },
    hasSpecialChars() {
      return /[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(this.password);
    },
    isValidPassword() {
      return (
        this.hasEightChars &&
        this.hasUpperCase &&
        this.hasLowercase &&
        this.hasNumber &&
        this.hasSpecialChars &&
        this.password == this.password_confirmation
      );
    },
  },
  mixins: [changeInputField],
  methods: {
    submit() {
      this.loading = true;
      if (this.isValidPassword) {
        this.verifyAuthenticationCode();
      } else {
        this.loading = false;
        this.generateToast(
          "Please confirm that your password meets all requirement!",
          "error"
        );
      }
    },
    async verifyAuthenticationCode() {
      this.loading = true;
      let code = this.convertAuthCodeToNumbers();
      let request = {
        code,
      };
      let userId = localStorage.getItem("userId");
      // let quantumUserId = localStorage.getItem("quantumUserId");
      request.userId = userId;
      try {
        await this.$_verifySignupAuthenticationCode(request);
        this.handleVerifySuccessfulResponse();
      } catch (error) {
        this.handleError(error);
        this.codeSubmitted = true;
        this.successfullyVerified = false;
      }
      this.loading = false;
    },
    async submitPassword() {
      let code = this.convertAuthCodeToNumbers();
      this.loading = true;
      if (this.isValidPassword) {
        let request = {
          password: this.password,
          code,
        };
        // let quantumUserId = localStorage.getItem("quantumUserId");
        // request.userId = quantumUserId;
        let userId = localStorage.getItem("userId");
        request.userId = userId;
        try {
          const { data: response } = await this.$_submitNewUserPassword(
            request
          );

          localStorage.setItem("token", response.data.token);
          this.generateToast("Password successfully set!", "success");
          // this.saveAccountType()
          this.$router.push("/onboarding/account-owner");
        } catch (error) {
          this.handleError(error);
        }
      } else {
        this.loading = false;
        this.generateToast(
          "Your password does not meet all requirements!",
          "error"
        );
      }

      this.loading = false;
    },
    async saveAccountType() {
      let accountTypeObject = JSON.parse(localStorage.getItem("accountTypeObject"));
      this.savingAccountType = true;

      if (accountTypeObject.accountType != "N/A") {
        // accounttypeRequest
        let accountTypeRequest = {
          type: accountTypeObject.accountType,
        };
        let userId = localStorage.getItem("userId");
        accountTypeRequest.userId = userId;

        let userCaseRequest = {
          // can be termed use case
          onboardingType: accountTypeObject.mainAccountType,
        };
        // let quantumUserId = localStorage.getItem("quantumUserId");
        userCaseRequest.userId = userId;

        try {
          let usecaseresponse = await this.$_saveUserUseCase(userCaseRequest);

          let acounttyperesponse = await this.$_saveUserAccountType(
            accountTypeRequest
          );
          Promise.all([usecaseresponse, acounttyperesponse]).then(() => {
            this.handleSuccessfulResponse();
          });
        } catch (error) {
          this.savingAccountType = false;
          this.handleError(error);
        }
      } else {
        this.savingAccountType = false;
        await this.generateToast(
          "Feature not available yet! try another..",
          "error"
        );
      }
    },
    handleSuccessfulResponse() {
      this.savingAccountType = false;
      this.storeTypeToLocalStorage();
      this.generateToast("Code verified!", "success");
      this.verifyingAuthCode = false;
      this.codeSubmitted = true;
      this.successfullyVerified = true;
      this.isCreatePassword = true;
      this.$router.push("/onboarding/account-owner");
    },
    async resendVerificationCode() {
      this.generateToast("Resending...", "success");
      const userId = localStorage.getItem("userId");
      const email = this.userEmail

      try {
        let response = await this.$_resendSignUpOtpCode({ userId, email });
        this.handleSuccessfulCodeResend();
        this.log(response);
      } catch (error) {
        this.handleError(error);
      }
    },
    handleSuccessfulCodeResend() {
      this.resendingVerificationCode = false;
      this.codeSubmitted = false;
      this.verificationResent = true;
      this.generateToast(
        "A new verification code has been sent to your email address!",
        "success"
      );
    },
    convertAuthCodeToNumbers() {
      let {
        first,
        second,
        third,
        fourth,
        fifth,
        sixth,
      } = this.authenticationCode;
      let authCodeNumbers = first + second + third + fourth + fifth + sixth;
      return authCodeNumbers;
    },
    handleVerifySuccessfulResponse() {
      this.generateToast("Code verified!", "success");
      this.verifyingAuthCode = false;
      this.codeSubmitted = true;
      this.successfullyVerified = true;
      this.isCreatePassword = true;
    },
    handleUnsuccessfulResponse() {
      this.verifyingAuthCode = false;
      this.verified = true;
      this.successfullyVerified = false;
    },
    resetCodeFields() {
      this.authenticationCode = {
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      };
    },
    pasteCode(e) {
      e.preventDefault();
      let code = e.clipboardData.getData("text/plain");
      if (code.length == 6) {
        this.authenticationCode = {
          first: code.charAt(0),
          second: code.charAt(1),
          third: code.charAt(2),
          fourth: code.charAt(3),
          fifth: code.charAt(4),
          sixth: code.charAt(5),
        };
      } else {
        this.generateToast("Invalid code entered!", "error");
        this.authenticationCode.first = "";
      }
    },
  },
};
</script>

<style scoped>
.single-code-input {
  width: 2.5rem;
  height: 3rem;
  /* width: 3rem;
  height: 3.5rem; */
  background: #ffffff;
  border: 1px solid #b8c4de;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 1rem;
  margin: 0 0.55rem;
  margin-bottom: 7px;
}

.single-code-input::placeholder {
  font-weight: normal;
  font-size: 1rem;
}

.single-code-input[type="text"] {
  font-size: 2rem;
  text-align: center;
  font-weight: bold;
  color: rgba(82, 82, 82, 0.3);
}
</style>
